import PropTypes from "prop-types";
import { useClientContext } from "../../ClientContext.jsx";
import { RADIUS } from "../../shared/theme.js";

export default function AssetTablesSection({ importParsed }) {
  const { T } = useClientContext();

  if (!importParsed || importParsed.type === "informe_ir") return null;

  return (
    <>
      {/* Amostra de ativos XP */}
      {importParsed.assets_xp &&
        (() => {
          const all = Object.values(importParsed.assets_xp).flat().slice(0, 5);
          if (!all.length) return null;
          return (
            <div style={{ marginBottom: 16 }}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: T.sub,
                  marginBottom: 8,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                Amostra de posições XP ({Object.values(importParsed.assets_xp).flat().length} total)
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr>
                    {["Nome", "Tipo", "Taxa", "Valor Bruto", "Vencimento"].map((h) => (
                      <th
                        key={h}
                        style={{
                          textAlign: "left",
                          padding: "6px 10px",
                          borderBottom: `1px solid ${T.border}`,
                          color: T.sub,
                          fontSize: 11,
                          fontWeight: 600,
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {all.map((a, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? T.row1 : T.row2 }}>
                      <td
                        style={{
                          padding: "6px 10px",
                          color: T.text,
                          fontWeight: 600,
                          maxWidth: 220,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {a.n}
                      </td>
                      <td style={{ padding: "6px 10px", color: T.sub }}>{a.tipo}</td>
                      <td style={{ padding: "6px 10px", color: T.sub }}>{a.taxa}</td>
                      <td style={{ padding: "6px 10px", color: T.text }}>
                        R$ {(a.v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                      </td>
                      <td style={{ padding: "6px 10px", color: T.sub }}>{a.venc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {Object.values(importParsed.assets_xp).flat().length > 5 && (
                <div style={{ fontSize: 11, color: T.muted, textAlign: "center", marginTop: 6 }}>
                  + {Object.values(importParsed.assets_xp).flat().length - 5} posições omitidas no
                  preview
                </div>
              )}
            </div>
          );
        })()}

      {/* Amostra de ativos BTG */}
      {importParsed.assets_btg && importParsed.assets_btg.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: T.sub,
              marginBottom: 8,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Ativos BTG ({importParsed.assets_btg.length} CDBs)
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead>
              <tr>
                {["Código", "Emissão", "Vencimento", "Original", "Bruto", "Líquido"].map((h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "6px 10px",
                      borderBottom: `1px solid ${T.border}`,
                      color: T.sub,
                      fontSize: 11,
                      fontWeight: 600,
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {importParsed.assets_btg.slice(0, 8).map((a, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? T.row1 : T.row2 }}>
                  <td
                    style={{
                      padding: "6px 10px",
                      color: T.text,
                      fontWeight: 600,
                      fontSize: 11,
                    }}
                  >
                    {a.code}
                  </td>
                  <td style={{ padding: "6px 10px", color: T.sub }}>{a.em}</td>
                  <td style={{ padding: "6px 10px", color: T.sub }}>{a.vc}</td>
                  <td style={{ padding: "6px 10px", color: T.text }}>
                    R$ {(a.orig || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                  </td>
                  <td style={{ padding: "6px 10px", color: T.text }}>
                    R$ {(a.bruto || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                  </td>
                  <td style={{ padding: "6px 10px", color: "#16A34A" }}>
                    R$ {(a.liq || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Amostra de ativos Inter / Interwin */}
      {importParsed.assets_inter && importParsed.assets_inter.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: T.sub,
              marginBottom: 8,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Posições Inter / Interwin ({importParsed.assets_inter.length} ativos)
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead>
              <tr>
                {["Ticker", "Nome", "Estratégia", "Saldo Bruto", "Rent. Mês", "Participação"].map(
                  (h) => (
                    <th
                      key={h}
                      style={{
                        textAlign: "left",
                        padding: "6px 10px",
                        borderBottom: `1px solid ${T.border}`,
                        color: T.sub,
                        fontSize: 11,
                        fontWeight: 600,
                      }}
                    >
                      {h}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {importParsed.assets_inter.slice(0, 8).map((a, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? T.row1 : T.row2 }}>
                  <td
                    style={{
                      padding: "6px 10px",
                      color: T.text,
                      fontWeight: 700,
                      fontSize: 11,
                    }}
                  >
                    {a.ticker}
                  </td>
                  <td
                    style={{
                      padding: "6px 10px",
                      color: T.sub,
                      maxWidth: 180,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {a.nome}
                  </td>
                  <td style={{ padding: "6px 10px" }}>
                    <span
                      style={{
                        background: "#FEF3C7",
                        color: "#92400E",
                        borderRadius: RADIUS.sm,
                        padding: "2px 6px",
                        fontSize: 10,
                        fontWeight: 700,
                      }}
                    >
                      {a.estrategia || "–"}
                    </span>
                  </td>
                  <td style={{ padding: "6px 10px", color: T.text }}>
                    R${" "}
                    {(a.saldo_bruto || 0).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td
                    style={{
                      padding: "6px 10px",
                      color: (a.rent_mes || 0) >= 0 ? "#16A34A" : "#DC2626",
                      fontWeight: 600,
                    }}
                  >
                    {a.rent_mes != null ? `${a.rent_mes.toFixed(2)}%` : "–"}
                  </td>
                  <td style={{ padding: "6px 10px", color: T.sub }}>
                    {a.participacao != null ? `${a.participacao.toFixed(2)}%` : "–"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {importParsed.assets_inter.length > 8 && (
            <div style={{ fontSize: 11, color: T.muted, textAlign: "center", marginTop: 6 }}>
              + {importParsed.assets_inter.length - 8} posições omitidas no preview
            </div>
          )}
        </div>
      )}

      {/* Amostra de posições Avenue */}
      {(importParsed.positions || importParsed.positions_avenue)?.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: T.sub,
              marginBottom: 8,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Posições Avenue ({(importParsed.positions || importParsed.positions_avenue).length}{" "}
            ativos)
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead>
              <tr>
                {["Ticker", "Qtd", "Preço", "Valor (USD)"].map((h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "6px 10px",
                      borderBottom: `1px solid ${T.border}`,
                      color: T.sub,
                      fontSize: 11,
                      fontWeight: 600,
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(importParsed.positions || importParsed.positions_avenue).slice(0, 8).map((p, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? T.row1 : T.row2 }}>
                  <td style={{ padding: "6px 10px", color: T.text, fontWeight: 700 }}>
                    {p.ticker}
                  </td>
                  <td style={{ padding: "6px 10px", color: T.sub }}>{p.shares}</td>
                  <td style={{ padding: "6px 10px", color: T.sub }}>
                    $ {(p.price || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                  </td>
                  <td style={{ padding: "6px 10px", color: T.text, fontWeight: 600 }}>
                    $ {(p.value || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

AssetTablesSection.propTypes = {
  importParsed: PropTypes.object,
};
